import React, { ReactElement, useState } from "react";
import Modal from "react-modal";
import { useDispatch } from "react-redux";

import { validateToken } from "src/reducers/utils";
import { callReport, StaffReportKey } from "src/api/staffReports/seityHealthAPI-staffReports";
import { downloadBlobFile } from "src/_core/utils/dataUtils/dataUtils";

import "./styles.scss";

const closeIcon = require("../../assets/images/web-icons/close.svg").default;
const circleLoader = require("../../assets/images/gifs/circleLoader.gif");

export type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export const StaffReports = ({ isOpen, onClose }): ReactElement => {
  const dispatch = useDispatch();

  const [isAccountReportLoading, setIsAccountReportLoading] = useState(false);
  const [isGroupReportLoading, setIsGroupReportLoading] = useState(false);
  const [isChallengeReportLoading, setIsChallengeReportLoading] = useState(false);
  const [isSeityProReportLoading, setIsSeityProReportLoading] = useState(false);
  const [error, setError] = useState(false);

  const runReport = async (reportKey: StaffReportKey, setLoading: (value: boolean) => void) => {
    setLoading(true);
    setError(false);
    try {
      const token = await validateToken(dispatch);
      const { blob, fileName } = await callReport(token, reportKey);
      downloadBlobFile(blob, fileName);
    } catch (err) {
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  const onCloseHandler = () => {
    onClose();
    setError(false);
  };

  return (
    <Modal isOpen={isOpen} className="sr-modal" overlayClassName="sr-modal-overlay">
      <div className="sr-wrapper">
        <div className="sr-header">
          <div className="sr-header-title">Staff Reports</div>
          <button onClick={onCloseHandler} type="button" className="sr-close-btn">
            <img src={closeIcon} alt="close" />
          </button>
        </div>
        <div className="sr-main">
          Please select the report you would like to download.
          <div className="sr-main-error" style={{ display: error ? "flex" : "none" }}>
            Unable to download report at this time
          </div>
          <div className="sr-main-actions">
            <button
              onClick={() => runReport("SeityUserAccounts", setIsAccountReportLoading)}
              className="sr-report-btn"
              type="button"
            >
              {isAccountReportLoading ? <img className="sr-main-loader" src={circleLoader} alt="loader" /> : "User account list"}
            </button>
            <button
              onClick={() => runReport("SeityGroupsList", setIsGroupReportLoading)}
              className="sr-report-btn"
              type="button"
            >
              {isGroupReportLoading ? <img className="sr-main-loader" src={circleLoader} alt="loader" /> : "User group list"}
            </button>
            <button
              onClick={() => runReport("ChallengeStatus", setIsChallengeReportLoading)}
              className="sr-report-btn"
              type="button"
            >
              {isChallengeReportLoading ? <img className="sr-main-loader" src={circleLoader} alt="loader" /> : "Challenge status list"}
            </button>
            <button
              onClick={() => runReport("SeityProAccess", setIsSeityProReportLoading)}
              className="sr-report-btn"
              type="button"
            >
              {isSeityProReportLoading ? <img className="sr-main-loader" src={circleLoader} alt="loader" /> : "Seity Pro access list"}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default StaffReports;
